<div class="p-1 p-md-2 show-thumb-wrapper" [class.dpad-start]="dpadStart" dpadSelectable (focus)="focused.emit()" [scrollTo]="true" (click)="redirectToPage()" (keyup.enter)="redirectToPage()">
    <div class="show-thumb pointer">
        <a [routerLink]="routerLink">
            <div class="show-thumb-image-wrapper">
                <div>
                    <picture>
                        <source *ngIf="item && item.imageUrl" srcset="{{item.imageUrl + '?width=250'}}">
                        <img class="thumb-image h-100 w-100" src="{{config.remoteConfig.loading_packshot}}"
                             alt="Loading Image"/>
                    </picture>
                </div>
            </div>
        </a>
    </div>
</div>

